import React from "react";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/home.css";

const Shipping = () => {
  return (
    <div className="legal-container">
      <Navbar />

      <div className="legal-content">
        <h1>Shipping Policy</h1>

        <p>Last Updated: March 2026</p>

        <h2>Delivery Time</h2>
        <p>
          Orders are typically delivered within 3-7 business days depending on
          your location.
        </p>

        <h2>Shipping Charges</h2>
        <p>
          Shipping charges may vary depending on the delivery location and
          order value.
        </p>

        <h2>Order Tracking</h2>
        <p>
          Once your order is shipped, tracking details will be sent to your
          registered email address.
        </p>

        <h2>Order Processing</h2>
<p>
Orders are processed within 1-2 business days after payment confirmation.
Orders are not processed on Sundays or public holidays.
</p>

      </div>

      <BottomNav />
    </div>
  );
};

export default Shipping;